import { container } from "../../../material-kit-react";

const completedStyle = {
  section: {
    padding: "70px 0"
  },
  container: {
    ...container,
    textAlign: "center !important"
  }
};

export default completedStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/componentsSections/completedStyle.jsx